import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

/** Faux tant que le build n'a pas reçu VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY. */
export const supabaseConfigured = Boolean(url && key);

// Sans configuration on instancie quand même un client vers une URL inerte :
// App affiche un écran explicite et aucune requête ne part. Mieux qu'un throw
// à l'import, qui donnerait une page blanche sans explication.
export const supabase = createClient<Database>(url ?? "https://unconfigured.invalid", key ?? "unconfigured", {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
